import type { KnowledgeHubSteps } from 'api/endpoints/knowledge-hub/knowledge-hub.types';

export const KNOWLEDGE_HUB_STEPS = [
  {
    name: 'files',
    title: 'KnowledgeHub:checklist.steps.files.title',
    url: '/knowledge-hub/files',
  },
  {
    name: 'variables',
    title: 'KnowledgeHub:checklist.steps.variables.title',
    url: '/knowledge-hub/variables',
  },
  {
    name: 'products',
    title: 'KnowledgeHub:checklist.steps.products.title',
    url: '/knowledge-hub/products',
  },
  {
    name: 'positioning',
    title: 'KnowledgeHub:checklist.steps.positioning.title',
    url: '/knowledge-hub/positioning',
  },
  {
    name: 'competitors',
    title: 'KnowledgeHub:checklist.steps.competitors.title',
    url: '/knowledge-hub/competitors',
  },
  {
    name: 'done',
    title: '',
    url: '/knowledge-hub/done',
  },
] as Omit<KnowledgeHubSteps[number], 'status'>[];

export const ADD_ROW_BUTTON_ID = 'add-row';
export const MINIMUM_USE_CASE_ROWS = 6;
export const USE_CASE_NAME_INPUT_ID = 'use-case-name';
export const DEBOUNCE_DELAY_MILLIS = 750;
export const MAX_SEGMENT_SELECTION = 3;

type FileType = {
  name: string;
  mimeType: string[];
};
export const ALLOWED_FILES: FileType[] = [
  {
    name: 'PDF Document (.pdf)',
    mimeType: ['application/pdf'],
  },
  {
    name: 'Word Document (.doc, .docx)',
    mimeType: [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
    ],
  },
  {
    name: 'PowerPoint Document (.ppt, .pptx)',
    mimeType: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
  },
  {
    name: 'Spreadsheet (.xls, .xlsx)',
    mimeType: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
  },
  {
    name: 'Plain Text (.txt) / Rich Text (.rtf)',
    mimeType: ['text/plain', 'text/rtf', 'application/rtf'],
  },
];

export const ALLOWED_FILE_TYPES = ALLOWED_FILES.reduce(
  (acc: string[], fileType: FileType) => {
    return acc.concat(fileType.name);
  },
  [],
);

export const ALLOWED_MIME_TYPES = ALLOWED_FILES.reduce(
  (acc: string[], fileType: FileType) => {
    return acc.concat(fileType.mimeType);
  },
  [],
);

export const KNOWLEDGE_HUB_SEGMENTS = [
  {
    name: 'Buyer Persona',
    description: 'KnowledgeHub:variables.segments.buyerPersona.description',
  },
  {
    name: 'Industry',
    description: 'KnowledgeHub:variables.segments.industry.description',
  },
  {
    name: 'Region',
    description: 'KnowledgeHub:variables.segments.region.description',
  },
  {
    name: 'Segment/Size',
    description: 'KnowledgeHub:variables.segments.segmentAndSize.description',
  },
  {
    name: 'Technology',
    description: 'KnowledgeHub:variables.segments.technology.description',
  },
  {
    name: 'Use Case',
    description: 'KnowledgeHub:variables.segments.useCase.description',
  },
];
